export default "__VITE_ASSET__BAgWWcLd__"